function navigationAccordion(){
  $('.nav a').on('click', function(e) {
    let $this = $(this);
    let $dropDown = $this.parent().find('.sub-menu').eq(0);
    if ($dropDown.length) {
      e.preventDefault();
      $dropDown.stop(true).slideToggle(300)
    }
  })
}

export default navigationAccordion();



// WEBPACK FOOTER //
// ../markup/assets/js/navigation-accordion.js